import type { DiskUsage } from '../types/metrics';

/**
 * Sürücü adını karşılaştırma için normalize eder (C -> C:, c: -> C:). Path içeren (Linux) değerlere ":" eklenmez.
 */
export const normalizeDriveName = (drive: string): string => {
  if (!drive || !String(drive).trim()) return '';
  let n = String(drive).trim().toUpperCase();
  if (n.length > 0 && !n.endsWith(':') && !n.includes('/')) n += ':';
  return n;
};

/**
 * Agent'ta disk listesi (DiskThresholds) tanımlıysa sadece o sürücüleri döndürür; boş/[] ise tüm diskleri döndürür.
 * Dashboard ve Metrics grid kartlarında "sadece girilen diskler" gösterimi için kullanılır.
 */
export const filterDiskUsageByAgentThresholds = (
  diskUsage: DiskUsage,
  diskThresholdsJson: string | undefined
): DiskUsage => {
  if (!diskThresholdsJson || String(diskThresholdsJson).trim() === '[]') return diskUsage;
  try {
    const thresholds = JSON.parse(diskThresholdsJson);
    if (!Array.isArray(thresholds) || thresholds.length === 0) return diskUsage;
    const allowed = new Set(
      thresholds
        .map((d: { drive?: string; Drive?: string }) => normalizeDriveName(d.drive ?? d.Drive ?? ''))
        .filter(Boolean)
    );
    const filtered: DiskUsage = {};
    Object.entries(diskUsage).forEach(([drive, usage]) => {
      if (allowed.has(normalizeDriveName(drive))) filtered[drive] = usage;
    });
    return filtered;
  } catch {
    return diskUsage;
  }
};
